const items = {
  "utilities.time.now": "now",
  "utilities.time.secs_ago": "secs ago",
  "utilities.time.mins_ago": "mins ago",
  "utilities.time.hs_ago": "hs ago",
  "utilities.time.days_ago": "days ago",
  "utilities.time.weeks_ago": "weeks ago",
  "utilities.time.months_ago": "months ago",
  "utilities.time.year_ago": "year ago",
  "utilities.time.years_ago": "years ago",
};

export default items;
